module.exports = __webpack_public_path__ + "img/娱乐配套_image.d01e5528.png";